import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function Training() {
  return (
    <div className="min-h-screen bg-white text-[#0a0a0a]">
      <Navbar />
      <main className="pt-32 pb-20">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">IDTA Academy AAS Training</h1>
            <p className="text-lg text-[#64748b] mb-12">
              Comprehensive training programs for Asset Administration Shell implementation.
            </p>
            
            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-bold mb-4">Training Programs</h2>
                <p className="text-[#64748b] mb-6">
                  Our training programs cover AAS fundamentals, implementation best practices, 
                  and advanced topics for digital twin development.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
                <p className="text-[#64748b] mb-4">
                  For training inquiries, please contact us at:
                </p>
                <p className="text-[#64748b]">
                  Email: <a href="mailto:academy@idtwin.org" className="text-[#0028CD] hover:underline">academy@idtwin.org</a><br />
                  Phone: +49 69 6603 1939
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Training;
